import React from "react";
import overViewTabRouter from "./overviewTabRouter";
import TabTemplate from "../../../_shoru_shared_library/template/TabTemplate";

function OverviewTab(props) {

  return (
    <TabTemplate 
      router={overViewTabRouter}
      passData={props.passData}
    />
  )

}

export default OverviewTab;